import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: stretch;
  gap: 2rem;
  flex: 1;

  transition: 0.3s;

  @media (max-width: ${props => props.theme.layout.breakpoints.md}) {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
    flex: 1;
  }
`;

export default Row;
